import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容导航",
    links: [
      { to: "/dramas", label: "短剧库" },
      { to: "/cast", label: "演员表查询" },
      { to: "/news", label: "爆料资讯" },
      { to: "/about", label: "关于我们" },
    ],
  },
  {
    title: "热门专题",
    links: [
      { to: "/news", label: "拍摄花絮" },
      { to: "/news", label: "幕后制作" },
      { to: "/news", label: "口碑解读" },
      { to: "/dramas", label: "古装权谋" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { to: "/about", label: "品牌介绍" },
      { to: "/about", label: "内容原则" },
      { to: "/about", label: "联系与订阅" },
      { to: "/about", label: "更新日志" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">短剧爆料社</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-secondary-200">
              专注爆料短剧的演员表查询、导演编剧信息与拍摄花絮，用尽量完整的幕后细节和口碑评分，帮你判断一部短剧值不值得追。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-700 text-secondary-200">
                <i className="ri-mail-line"></i>
              </span>
              <a
                href="mailto:hello@duanju-insider.example.com"
                className="text-sm text-secondary-100 underline-offset-4 hover:text-accent-400 hover:underline"
              >
                hello@duanju-insider.example.com
              </a>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50">
                <Link to={column.links[0].to} className="hover:text-accent-400">
                  {column.title}
                </Link>
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-200 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 短剧爆料社 · 内容仅供观剧参考，不含任何商业推广</p>
          <p>本站图片与剧集资料均用于内容讨论与信息整理</p>
        </div>
      </div>
    </footer>
  );
}